<div class="component application-history">
  <div class="e11-w-full e11-mb-8">
    <ng-container *ngIf="orderedApplicationHistory(); else LoadingApplicationHistory">
      <div class="empty-state text-center" *ngIf="orderedApplicationHistory()!.length === 0">
        <h4 class="text-grey italic">{{ 'No Application History' | translate }}</h4>
        <p class="text-grey">{{ 'There appears to be no application history for this application.' | translate }}</p>
      </div>

      <div class="" *ngIf="orderedApplicationHistory()!.length > 0">
        <div *ngFor="let historyItem of orderedApplicationHistory()" class="e11-mb-4">
          <p class="e11-mb-0">
            <ng-container *ngIf="historyItem.tokens?.length; else plainText">
              <ng-container *ngFor="let token of historyItem.tokens">
                <ng-container *ngIf="token.type === tokenType.JOB_POST_TITLE && token.id; else plainToken">
                  <a
                    href="#"
                    class="e11-underline e11-cursor-pointer"
                    (click)="onJobTitleClick({ id: token.id!, applicationId: token.applicationId }, $event)"
                    >{{ token.value }}</a
                  >
                </ng-container>
                <ng-template #plainToken
                  ><span>{{ token.value }}</span></ng-template
                >
              </ng-container>
            </ng-container>
            <ng-template #plainText>{{ historyItem.text }}</ng-template>
          </p>
          <p class="date e11-text-skin-light e11-text-sm">{{ historyItem.occurredAt | date : 'MMM d, y, h:mm a' }}</p>
        </div>
      </div>
    </ng-container>
    <ng-template #LoadingApplicationHistory>
      <div *ngFor="let i of 2 | range" class="e11-mb-4">
        <p class="e11-mb-2 e11-skeleton-empty"></p>
        <p class="e11-skeleton-empty"></p>
      </div>
    </ng-template>
  </div>
</div>
